module.exports = __webpack_public_path__ + "64be963e66416f81e78dd07efc615df7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/crows-feet/crows-feet-2b.jpg
 ** module id = 434
 ** module chunks = 0
 **/